import { Module, GetterTree, ActionTree, MutationTree } from 'vuex';
import { initialMutations } from '.';
import http from '@/http';

interface SystemDataState {
  timezones: string[];
  dateFormats: string[];
  timeFormats: string[];
}

const getInitialState = () => ({
  timezones: [],
  dateFormats: [
    'MMMM DD, YYYY',
    'DD MMMM, YYYY',
    'YYYY-MM-DD',
    'YYYY/MM/DD',
    'MM/DD/YYYY',
    'DD/MM/YYYY',
  ],
  timeFormats: ['hh:mm a', 'hh:mm A', 'HH:mm'],
});

const state: SystemDataState = {
  ...getInitialState(),
};

const getters: GetterTree<SystemDataState, RootState> = {};

const actions: ActionTree<SystemDataState, RootState> = {
  init({ commit }) {
    http.v1.sd.fetchAllTimezones().then((response) => {
      commit('SET_STATE', {
        key: 'timezones',
        payload: response.data.data,
      });
    });
  },
};

const mutations: MutationTree<SystemDataState> = {
  ...initialMutations,
};

const tour: Module<SystemDataState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default tour;
